import { Context } from '@hotwired/stimulus';
import { emitter } from 'src/emitter';
import {
  emitPickedType,
  EVENT_ESCAPE,
  EVENT_INPUT,
  EVENT_SET_STATE,
  isActionPickType,
  isEventInput,
  isEventSetState,
} from './events';
import SearchBarModalController from './modal_controller';

export const STATE_TOKEN_TYPE = 'token:type';
export const STATE_TOKEN_TYPE_ACTIVE = 'token:type:active';

export default class SearchBarTokenTypeModalController extends SearchBarModalController {
  constructor(context: Context) {
    super(context);

    this.onSearchBarStateChange = this.onSearchBarStateChange.bind(this);
    this.onSearchBarInput = this.onSearchBarInput.bind(this);
    this.onSearchBarEscape = this.onSearchBarEscape.bind(this);
  }

  public connect(): void {
    super.connect();

    emitter.on(EVENT_SET_STATE, this.onSearchBarStateChange);
    emitter.on(EVENT_INPUT, this.onSearchBarInput);
    emitter.on(EVENT_ESCAPE, this.onSearchBarEscape);
  }

  public disconnect(): void {
    super.disconnect();

    emitter.off(EVENT_SET_STATE, this.onSearchBarStateChange);
    emitter.off(EVENT_INPUT, this.onSearchBarInput);
    emitter.off(EVENT_ESCAPE, this.onSearchBarEscape);
  }

  private onSearchBarStateChange(event: unknown) {
    if (!isEventSetState(event)) {
      return;
    }

    switch (event.state) {
      case STATE_TOKEN_TYPE: {
        this.activeItem = null;
        this.active = true;
        break;
      }

      case STATE_TOKEN_TYPE_ACTIVE: {
        if (!this.activeItem) {
          this.activateFirst();
        }
        this.active = true;
        break;
      }

      default: {
        this.activeItem = null;
        this.active = false;
      }
    }
  }

  private onSearchBarEscape(_: unknown) {
    if (!this.active) {
      return;
    }

    // noop
  }

  private onSearchBarInput(event: unknown) {
    if (!this.active || !isEventInput(event)) {
      return;
    }

    switch (event.key) {
      case 'ArrowDown': {
        this.activateNext();
        break;
      }

      case 'ArrowUp': {
        this.activatePrevious();
        break;
      }

      case 'Home': {
        this.activateFirst();
        break;
      }

      case 'End': {
        this.activateLast();
        break;
      }

      case 'Enter': {
        if (this.activeItem) {
          const type = this.activeItem.getAttribute(
            'data-search-bar--token-type-modal-type-param',
          );
          if (type) {
            this.pick({ params: { type } });
          }
        }

        break;
      }
    }
  }

  public pick(event: unknown) {
    if (!isActionPickType(event)) {
      return;
    }

    emitPickedType(event.params.type);
  }
}
